import { FC } from "react";

/**
 * Eye Icon Props Interface
 * @interface EyeProps
 */
interface DuplicateIconProps {

}

const DuplicateIcon: FC<DuplicateIconProps> = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
        d="M4.63636 7.09091C4.63636 6.63904 4.27005 6.27273 3.81818 6.27273C3.36631 6.27273 3 6.63904 3 7.09091V19.3636C3 20.2636 3.73636 21 4.63636 21H16.9091C17.361 21 17.7273 20.6337 17.7273 20.1818C17.7273 19.7299 17.361 19.3636 16.9091 19.3636H4.63636V7.09091ZM19.3636 3H7.90909C7.00909 3 6.27273 3.73636 6.27273 4.63636V16.0909C6.27273 16.9909 7.00909 17.7273 7.90909 17.7273H19.3636C20.2636 17.7273 21 16.9909 21 16.0909V4.63636C21 3.73636 20.2636 3 19.3636 3ZM19.3636 16.0909H7.90909V4.63636H19.3636V16.0909Z"
        fill="black"
        />
    </svg>
    </>
  );
};

export default DuplicateIcon;
